// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"6b61ed3d","239":"15d6f114","389":"98beeed6","732":"380422e0","977":"20dcdb7e"}[chunkId] + ".chunk.js";
};